export default "__VITE_ASSET__BnL0QplH__"